// extracted by mini-css-extract-plugin
module.exports = {"hccControl":"PatientsAddView_hccControl__1HE11","hccDelete":"PatientsAddView_hccDelete__19x73"};